import React, { useEffect, useState } from 'react';
import {
  getAllLogistics,
  getClientsByLogistics,
  getAllVials,
  createLogisticsEntry,
  getEntryForEdit,
  updateLogisticsEntry,
} from '../services/logisticsService';
import LogisticsSelectionModal from '../components/LogisticsSelectionModal';
import AppHeader from '../components/AppHeader';
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';

function LogisticsEntryPage() {
  const [logisticsList, setLogisticsList] = useState([]);
  const [selectedLogistics, setSelectedLogistics] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [clients, setClients] = useState([]);
  const [vials, setVials] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [entryDate, setEntryDate] = useState(new Date().toISOString().split('T')[0]);

  const [formData, setFormData] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [searchParams] = useSearchParams();
  const editId = searchParams.get('editId');

  const [isEditMode, setIsEditMode] = useState(false);
  const [editingEntryId, setEditingEntryId] = useState(null);
  const [clientSearch, setClientSearch] = useState('');

  const [selectedLogisticsId, setSelectedLogisticsId] = useState(null);
const [showLogisticsModal, setShowLogisticsModal] = useState(false);

      const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
const loggedInLogisticsId = storedUser?.logistics_person_id || null;

  useEffect(() => {
    fetchLogistics();


  }, []);

  const fetchLogistics = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await getAllLogistics();
      setLogisticsList(res.data?.data || []);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load logistics list');
    } finally {
      setLoading(false);
    }
  };

 
useEffect(() => {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
 
  if (user?.user_type === 'LOGISTICS') {
    setSelectedLogisticsId(user.logistics_person_id);
    setShowLogisticsModal(false);
  } else {
    setShowLogisticsModal(true);
  }
}, []);

useEffect(() => {
  const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
  const loggedInLogisticsId = storedUser?.logistics_person_id || null;
  console.log('Logged-in Logistics ID from localStorage:', loggedInLogisticsId);  
  setSelectedLogisticsId(loggedInLogisticsId);
  if (loggedInLogisticsId) {
    fetchClientsAndVials(loggedInLogisticsId);
  }
}, [loggedInLogisticsId]);

const autoSelectLogistics = async () => {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
 
  if (user?.user_type === 'LOGISTICS' && user?.logistics_person_id) {
    const response = await getAllLogistics();
    const logisticsList = response?.data?.data || [];
 
    const matched = logisticsList.find(
      (item) => item.id === user.logistics_person_id
    );
 
    if (matched) {
      setSelectedLogistics(matched);
      setSelectedLogisticsId(matched.id);
      setShowLogisticsModal(false);
      await getClientsByLogistics(matched.id);
    }
  } else {
    setShowLogisticsModal(true);
  }
};
 
useEffect(() => {
  autoSelectLogistics();
}, []);

 
useEffect(() => {
  const initializePage = async () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
 
    if (user?.user_type === 'LOGISTICS' && user?.logistics_person_id) {
      setSelectedLogisticsId(user.logistics_person_id);
      setShowLogisticsModal(false);
 
      try {
        const response = await getAllLogistics();
        const logisticsList = response?.data?.data || [];
 
        const matchedLogistics = logisticsList.find(
          (item) => item.id === user.logistics_person_id
        );
 
        if (matchedLogistics) {
          setSelectedLogistics(matchedLogistics);
        }
 
        await getClientsByLogistics(user.logistics_person_id);
      } catch (error) {
        console.log(error);
      }
    } else {
      setShowLogisticsModal(true);
    }
  };
 
  initializePage();
}, []);

  const initializeFormData = (clientsList, vialsList) => {
    const initialData = {};

    clientsList.forEach((client) => {
      initialData[client.id] = {};

      vialsList.forEach((vial) => {
        initialData[client.id][vial.id] = '';
      });
    });

    setFormData(initialData);
  };

  const handleSelectLogistics = async (item) => {
    setSelectedLogistics(item);
    setIsModalOpen(false);
    await fetchClientsAndVials(item.id);
  };

  const fetchClientsAndVials = async (logisticsId) => {
    try {
      setTableLoading(true);
      setError('');

      const [clientsRes, vialsRes] = await Promise.all([
        getClientsByLogistics(logisticsId),
        getAllVials(),
      ]);

      const clientsData = clientsRes.data?.data || [];
      const vialsData = vialsRes.data?.data || [];

      setClients(clientsData);
      setVials(vialsData);
      initializeFormData(clientsData, vialsData);

    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load clients and vials');
    } finally {
      setTableLoading(false);
    }
  };
  const today = new Date();
  const todayDate = today.toISOString().split('T')[0];

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const yesterdayDate = yesterday.toISOString().split('T')[0];

  const handleQtyChange = (clientId, vialId, value) => {
    if (value === '') {
      setFormData((prev) => ({
        ...prev,
        [clientId]: {
          ...prev[clientId],
          [vialId]: '',
        },
      }));
      return;
    }

    const numericValue = Math.max(0, Number(value));

    setFormData((prev) => ({
      ...prev,
      [clientId]: {
        ...prev[clientId],
        [vialId]: numericValue,
      },
    }));
  };

  const filteredClients = clients.filter((client) =>
    client.client_name.toLowerCase().includes(clientSearch.toLowerCase())
  );

  const fillFormWithEditData = (matrixData, clientsList, vialsList) => {
    const initialData = {};

    clientsList.forEach((client) => {
      initialData[client.id] = {};

      vialsList.forEach((vial) => {
        initialData[client.id][vial.id] = '';
      });
    });

    matrixData.forEach((clientRow) => {
      const clientId = clientRow.clientId;

      if (!initialData[clientId]) {
        initialData[clientId] = {};
      }

      Object.keys(clientRow.vials || {}).forEach((vialId) => {
        initialData[clientId][Number(vialId)] = clientRow.vials[vialId];
      });
    });

    setFormData(initialData);
  };

  const loadEntryForEdit = async (entryId) => {
    try {
      setLoading(true);
      setError('');
      setSuccessMessage('');

      const res = await getEntryForEdit(entryId);
      const editData = res.data?.data;

      if (!editData) {
        setError('Edit data not found');
        return;
      }

      const matchedLogistics = logisticsList.find(
        (item) => Number(item.id) === Number(editData.logisticsId)
      );

      if (!matchedLogistics) {
        setError('Logistics not found for this entry');
        return;
      }

      const [clientsRes, vialsRes] = await Promise.all([
        getClientsByLogistics(editData.logisticsId),
        getAllVials(),
      ]);

      const clientsData = clientsRes.data?.data || [];
      const vialsData = vialsRes.data?.data || [];

      setSelectedLogistics(matchedLogistics);
      setIsModalOpen(false);
      setClients(clientsData);
      setVials(vialsData);
      setEntryDate(editData.entryDate);
      setIsEditMode(true);
      setEditingEntryId(Number(entryId));

      fillFormWithEditData(editData.matrix || [], clientsData, vialsData);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load edit entry');
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    if (editId && logisticsList.length > 0) {
      loadEntryForEdit(editId);
    }
  }, [editId, logisticsList]);

  const handleSubmit = async () => {

    try {
      setSubmitLoading(true);
      setError('');
      setSuccessMessage('');

      if (!selectedLogistics) {
        setError('Please select a logistics person');
        return;
      }

      const items = [];

      Object.keys(formData).forEach((clientId) => {
        Object.keys(formData[clientId] || {}).forEach((vialId) => {
          const qty = formData[clientId][vialId];

          if (qty !== '' && Number(qty) > 0) {
            items.push({
              clientId: Number(clientId),
              vialId: Number(vialId),
              qty: Number(qty),
            });
          }
        });
      });

      if (items.length === 0) {
        setError('Please enter at least one vial quantity');
        return;
      }

      const payload = {
        logisticsId: loggedInLogisticsId || selectedLogistics.id,
        entryDate,
        items,
      };

      const res = isEditMode
        ? await updateLogisticsEntry(editingEntryId, payload)
        : await createLogisticsEntry(payload);

      Swal.fire({
        icon: 'success',
        title: isEditMode ? 'Entry Updated Successfully' : 'Entry Submitted Successfully',
        text: 'Logistics vial entry saved successfully.',
        width: '380px',
        padding: '1.4rem',
        showConfirmButton: false,
        timer: 2200,
        timerProgressBar: true,
        backdrop: 'rgba(15,23,42,0.35)',
        customClass: {
          popup: 'vial-success-popup',
          title: 'vial-popup-title',
          htmlContainer: 'vial-popup-text'
        },
        showClass: {
          popup: 'animate__animated animate__zoomIn animate__faster'
        },
        hideClass: {
          popup: 'animate__animated animate__zoomOut animate__faster'
        }
      });

      if (isEditMode) {
        setIsEditMode(false);
        setEditingEntryId(null);
        window.history.replaceState({}, '', '/');
      }

      initializeFormData(clients, vials);
      initializeFormData(clients, vials);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to submit entry');
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setEditingEntryId(null);
    setSuccessMessage('');
    setError('');
    window.history.replaceState({}, '', '/');

    if (selectedLogistics) {
      initializeFormData(clients, vials);
    }
  };

  const handleResetForm = () => {
    setFormData((prev) => {
      const clearedData = {};

      Object.keys(prev).forEach((clientId) => {
        clearedData[clientId] = {};

        Object.keys(prev[clientId] || {}).forEach((vialId) => {
          clearedData[clientId][vialId] = '';
        });
      });

      return clearedData;
    });

    setSuccessMessage('');
    setError('');
  };

  const totalEnteredVials = Object.values(formData).reduce((clientSum, clientRow) => {
    const rowTotal = Object.values(clientRow || {}).reduce((sum, qty) => {
      return sum + (qty === '' ? 0 : Number(qty || 0));
    }, 0);

    return clientSum + rowTotal;
  }, 0);

  return (
    <div style={pageStyle}>
      <AppHeader />
      <div style={heroBoxStyle}>
        <h2 style={{ margin: 0 }}>Logistics Vial Data Entry</h2>
        <p style={{ marginTop: '8px', color: '#475569' }}>
          Select a logistics person, enter client-wise vial quantities, and submit daily tracking data.
        </p>
      </div>

      {loading && <p>Loading logistics...</p>}

      {error && (
        <div style={errorBoxStyle}>
          {error}
        </div>
      )}

      {successMessage && (
        <div style={successBoxStyle}>
          {successMessage}
        </div>
      )}

      {selectedLogistics && (
        <div style={selectedBoxStyle}>
          <h3>Selected Logistics</h3>
          <p><strong>Name:</strong> {selectedLogistics.name}</p>
          <p><strong>Code:</strong> {selectedLogistics.code || 'N/A'}</p>
          <p><strong>Total Clients:</strong> {clients.length}</p>
          <p><strong>Total Vials:</strong> {vials.length}</p>
          {tableLoading && <p>Loading clients and vials...</p>}
          <p><strong>Total Entered Vials:</strong> {totalEnteredVials}</p>
          {/* <button onClick={() => setIsModalOpen(true)} style={buttonStyle}>
            Change Logistics
          </button> */}
        </div>
      )}

      {!selectedLogistics && !loading && (
        <button onClick={() => setIsModalOpen(true)} style={buttonStyle}>
          Select Logistics Person
        </button>
      )}

      {selectedLogistics && (
        <div style={selectedBoxStyle}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Entry Date
          </label>
          <input
            type="date"
            value={entryDate}
            min={yesterdayDate}
            max={todayDate}
            onChange={(e) => setEntryDate(e.target.value)}
            style={inputStyle}
          />
          <p style={{ marginTop: '8px', color: '#64748b', fontSize: '14px' }}>
            Only today and yesterday can be selected.
          </p>
        </div>
      )}

      {selectedLogistics && !tableLoading && clients.length > 0 && vials.length > 0 && (
        <div style={tableWrapperStyle}>
          {isEditMode && (
            <div
              style={{
                marginTop: '16px',
                padding: '12px 16px',
                backgroundColor: '#dbeafe',
                color: '#1e3a8a',
                borderRadius: '8px',
                fontWeight: '600',
                maxWidth: '500px',
              }}
            >
              Edit Mode Active — Updating Entry ID: {editingEntryId}
            </div>
          )}

          {selectedLogistics && clients.length > 0 && (
            <div style={selectedBoxStyle}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                Search Client
              </label>
              <input
                type="text"
                value={clientSearch}
                onChange={(e) => setClientSearch(e.target.value)}
                placeholder="Type client name"
                style={inputStyle}
              />
            </div>
          )}

          <div style={{ marginTop: '16px', overflowX: 'auto', whiteSpace: 'nowrap', }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Client Name</th>
                  {vials.map((vial) => (
                    <th key={vial.id} style={thStyle}>
                      {/* {vial.vial_name} */}
                      <div style={vialHeaderWrapStyle}>
                      <span>{vial.vial_name}</span>

                      <span
                        style={{
                          ...vialColorDotStyle,
                          background: vial.color_code || '#cbd5e1',
                        }}
                      />
                    </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredClients.length > 0 ? (
                  filteredClients.map((client) => (
                    <tr key={client.id}>
                      <td style={tdStyle}>{client.client_name}</td>
                      {vials.map((vial) => (
                        <td key={vial.id} style={tdStyle}>
                          <input
                            type="number"
                            min="0"
                            placeholder="0"
                            value={formData?.[client.id]?.[vial.id] ?? ''}
                            onChange={(e) => handleQtyChange(client.id, vial.id, e.target.value)}
                            style={tableInputStyle}
                          />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={tdStyle} colSpan={vials.length + 1}>
                      No matching clients found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      )}

      {selectedLogistics && !tableLoading && clients.length > 0 && vials.length > 0 && (
        <div
          style={{
            marginTop: '16px',
            padding: '12px 16px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            maxWidth: '300px',
            fontWeight: '600',
          }}
        >
          Total Entered Vials: {totalEnteredVials}
        </div>
      )}

      {selectedLogistics && !tableLoading && clients.length > 0 && vials.length > 0 && (
        <div style={{ marginTop: '20px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={handleSubmit}
            disabled={submitLoading}
            style={{
              ...buttonStyle,
              opacity: submitLoading ? 0.7 : 1,
            }}
          >
            {submitLoading
              ? (isEditMode ? 'Updating...' : 'Submitting...')
              : (isEditMode ? 'Update Entry' : 'Submit Entry')}
          </button>

          <button
            onClick={handleResetForm}
            type="button"
            style={{
              ...buttonStyle,
              backgroundColor: '#475569',
            }}
          >
            Reset Form
          </button>

          {isEditMode && (
            <button
              onClick={handleCancelEdit}
              type="button"
              style={{
                ...buttonStyle,
                backgroundColor: '#64748b',
              }}
            >
              Cancel Edit
            </button>
          )}
        </div>
      )}

      {showLogisticsModal && <LogisticsSelectionModal
        isOpen={isModalOpen}
        logisticsList={logisticsList}
        selectedLogisticsId={selectedLogistics?.id}
        onSelect={handleSelectLogistics}
        onClose={() => setIsModalOpen(false)}
      />}
    </div> 
  );
}

const pageStyle = {
  padding: '24px',
};

const heroBoxStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  padding: '20px',
  marginBottom: '20px',
};

const selectedBoxStyle = {
  marginTop: '20px',
  marginBottom: '20px',
  padding: '16px',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

const errorBoxStyle = {
  marginTop: '16px',
  padding: '12px 16px',
  backgroundColor: '#fee2e2',
  color: '#991b1b',
  borderRadius: '8px',
  border: '1px solid #fecaca',
};

const successBoxStyle = {
  marginTop: '16px',
  padding: '12px 16px',
  backgroundColor: '#dcfce7',
  color: '#166534',
  borderRadius: '8px',
  border: '1px solid #bbf7d0',
};

const buttonStyle = {
  fontFamily: '"Mulish", sans-serif',
  padding: '10px 16px',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: '#0f172a',
  color: '#ffffff',
  cursor: 'pointer',
  marginTop: '12px',
};

const inputStyle = {
  width: '100%',
  maxWidth: '240px',
  padding: '10px 12px',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  fontSize: '14px',
};

const tableWrapperStyle = {
  marginTop: '20px',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  overflowX: 'auto',
  padding: '16px',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  minWidth: '700px',
};

const thStyle = {
  border: '1px solid #e2e8f0',
  padding: '12px',
  backgroundColor: '#f8fafc',
  textAlign: 'left',
};

const tdStyle = {
  border: '1px solid #e2e8f0',
  padding: '12px',
};

const tableInputStyle = {
  width: '80px',
  padding: '8px',
  border: '1px solid #cbd5e1',
  borderRadius: '6px',
};

const vialHeaderWrapStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
};

const vialColorDotStyle = {
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  display: 'inline-block',
  border: '1px solid #e2e8f0',
};
export default LogisticsEntryPage;